// Events sent to the Wizard to request a change (e.g. by Footer)
export enum WizardInputEventType {
  Close = "BmWizardClose",
  PreviousStep = "BmWizardPreviousStep",
  NextStep = "BmWizardNextStep",
  Finished = "BmWizardFinished",
}
